import Topbar from "../topbar/Topbar";

export default function Footer() {

    return (
        <Topbar />
    );
}